import { Service, BaseService } from '@/core/auto'
import { post } from '../../utils/request'

@Service('/api/usr')
export default class LessonContent extends BaseService {
  init (data) {
    return this.request({
      url: '/popElgSco/init',
      data: data,
      method: 'POST'
    })
  };

  check () {
    return this.request({
      url: '/popElgSco/check',
      method: 'POST'
    })
  };

  initPopSco (data) {
    return this.request({
      url: '/popSco/init',
      data: data,
      method: 'POST'
    })
  };

  updatePopSco (data) {
    return this.request({
      url: '/popSco/update',
      data: data,
      method: 'POST'
    })
  }
}

export async function regularUpdatePopSco(formData) {
  return post('/api/usr/popSco/update', formData)
}

export async function initPopElgSco(formData) {
  return post('/api/usr/popElgSco/init', formData)
}
